document.addEventListener("DOMContentLoaded", () => {
    const body = document.body;

    const modal = document.querySelector(".video-modal");
    const video = document.querySelector(".video-modal__video");
    const closeButton = document.querySelector(".video-modal__close");
    const overlay = document.querySelector(".video-modal__overlay");
    const triggers = document.querySelectorAll(".video-card__trigger");

    if(!modal || !video) return;

    // モーダルを開く
    function openModal(videoUrl) {
        video.src = videoUrl;
        modal.hidden = false;
        modal.classList.remove("is-hidden");

        video.load();
        video.play();
    }

    // モーダルを閉じる
    function closeModal() {
        video.pause();
        video.removeAttribute("src");
        video.load();

        modal.hidden = true;
        body.classList.add("is-hidden");
    }

    // サムネイルクリック
    triggers.forEach(trigger => {
        trigger.addEventListener("click", () => {
            const videoUrl = trigger.dataset.video;
            if(!videoUrl) return;

            openModal(videoUrl);
        });
    });

    // ×ボタン
    closeButton.addEventListener("click", closeModal);

    // オーバーレイクリック
    overlay.addEventListener("click", closeModal);

    // 動画
    video.addEventListener('click', function(event){
        event.stopPropagation();
    });

    // ESCキー
    document.addEventListener("keydown", event => {
        if (event.key === "Escape" && !modal.hidden) {
            closeModal();
        }
    });
});